import type { ChangeEventHandler } from 'react';
import { useMemo, useState } from 'react';

export const useRadioControl = ({
  valueProp,
  onChangeProp,
}: {
  valueProp: string
  onChangeProp?: ChangeEventHandler<HTMLInputElement>
}) => {
  const isControlled = useMemo(() => valueProp !== undefined, [])
  const [uncontrolledValue, setUncontrolledValue] = useState(undefined)

  const value = isControlled ? valueProp : uncontrolledValue

  const onChangeFn: ChangeEventHandler<HTMLInputElement> = isControlled
    ? onChangeProp
    : (e) => {
        setUncontrolledValue(e.target.value)
      }

  return {
    value,
    onChange: onChangeFn,
  }
}
